export default {
    /**
     * 调试模式
     */
    debug:false,
    /**
     * 在app端显示toast
     */
    toastShowLog: false,
    /**
     * 授权(仅用于在10.110.30.109进行测试)
     */
    anonymousAuth: false

}
